module.exports = __webpack_public_path__ + "img/loginLogin1.8575cf07.png";